var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"Right Panel"}}),_vm._v(" "),_c('f7-block-title',[_vm._v("Parts in current steps")]),_vm._v(" "),_c('f7-list',_vm._l((_vm.currentStepListItem),function(item,key){return _c('f7-list-item',{key:key,attrs:{"title":item}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a2ca32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partial/panel-right.vue
// module id = null
// module chunks = 